<template>
  <div class="rb-page">
    <!-- 顶部 Header -->
    <div class="rb-header">
      <div class="rb-header-left">
        <i class="el-icon-back rb-back" @click="$router.go(-1)">返回</i>
        <span class="rb-divider-v"></span>
        <span class="rb-label">编号</span>
        <span class="rb-value">{{ pcode }}</span>
        <span class="rb-label">项目</span>
        <span class="rb-value">{{ pname }}</span>
        <span class="rb-divider-v"></span>
        <el-tag size="small" type="primary" effect="dark" class="rb-tag-live">
          <i class="el-icon-s-platform"></i> Live 管控
        </el-tag>
      </div>
      <div class="rb-header-right">
        <span class="rb-count-total">共 <b>{{ projects.length }}</b> 个项目</span>
      </div>
    </div>

    <!-- 状态统计 -->
    <div class="rb-stats">
      <div class="rb-stat-item rb-stat-running" @click="filterKey = filterKey === 'running' ? '' : 'running'" :class="{ active: filterKey === 'running' }">
        <div class="rb-stat-dot"></div>
        <div class="rb-stat-num">{{ statCounts.running }}</div>
        <div class="rb-stat-label">进行中</div>
      </div>
      <div class="rb-stat-item rb-stat-completed" @click="filterKey = filterKey === 'completed' ? '' : 'completed'" :class="{ active: filterKey === 'completed' }">
        <div class="rb-stat-dot"></div>
        <div class="rb-stat-num">{{ statCounts.completed }}</div>
        <div class="rb-stat-label">已完成</div>
      </div>
      <div class="rb-stat-item rb-stat-not_running" @click="filterKey = filterKey === 'not_running' ? '' : 'not_running'" :class="{ active: filterKey === 'not_running' }">
        <div class="rb-stat-dot"></div>
        <div class="rb-stat-num">{{ statCounts.not_running }}</div>
        <div class="rb-stat-label">未运行</div>
      </div>
      <div v-if="filterKey" class="rb-stat-clear" @click="filterKey = ''">
        <i class="el-icon-close"></i> 清除筛选
      </div>
    </div>

    <!-- 批量操作卡片 -->
    <el-card shadow="never" class="rb-card rb-card-controls">
      <div slot="header" class="rb-card-header">
        <i class="el-icon-set-up"></i>
        <span>批量操作</span>
        <span class="rb-card-hint">设置启动参数后，可对全部项目统一发起运行 / close / 刷新 / 上传 logic</span>
      </div>

      <div class="rb-control-grid">
        <div class="rb-control-row">
          <div class="rb-control-cell">
            <label class="rb-form-label">总数</label>
            <el-input v-model="paoparam.total" placeholder="如：500" size="small" clearable></el-input>
          </div>
          <div class="rb-control-cell">
            <label class="rb-form-label">并发数</label>
            <el-input v-model="paoparam.threads" placeholder="如：5" size="small" clearable></el-input>
          </div>
          <div class="rb-control-cell">
            <label class="rb-form-label">震荡步长</label>
            <el-input v-model="paoparam.step" placeholder="如：0" size="small" clearable></el-input>
          </div>
        </div>
        <div class="rb-control-row rb-control-row-btns">
          <el-button type="primary" size="small" icon="el-icon-video-play" :loading="batchRunning" @click="batchRun">
            全部运行
          </el-button>
          <el-button type="danger" size="small" icon="el-icon-circle-close" :loading="batchClosing" @click="batchClose" plain>
            全部 close
          </el-button>
         
          <el-upload
            class="rb-upload-inline"
            name="logic"
            :action="batchLogicUpUrl"
            :headers="{ Authorization: token }"
            :data="{ pids: pidsJson }"
            auto-upload
            :show-file-list="false"
            :before-upload="beforeBatchLogicUpload"
            :on-success="onBatchLogicSuccess"
            :on-error="onBatchLogicError"
          >
            <el-button type="warning" size="small" icon="el-icon-upload2" :loading="batchLogicUploading" plain>
              上传 logic（全部）
            </el-button>
          </el-upload>
          <el-button size="small" icon="el-icon-delete" @click="batchRemove" plain class="rb-btn-light" :disabled="selectedProjects.length === 0">
            批量移除
          </el-button>
          <el-button size="small" icon="el-icon-refresh" :loading="refreshing" @click="refreshAll" plain>
            刷新
          </el-button>
        </div>
      </div>
    </el-card>

    <!-- 项目列表 -->
    <el-card shadow="never" class="rb-card rb-card-list">
      <div slot="header" class="rb-card-header">
        <i class="el-icon-s-grid"></i>
        <span>项目列表</span>
        <span class="rb-card-hint">按 进行中 → 已完成 → 未运行 自动排序</span>
      </div>

      <div v-if="loading" class="rb-loading">
        <i class="el-icon-loading rb-loading-icon"></i>
        <p class="rb-loading-text">正在加载项目数据...</p>
      </div>

      <div v-else-if="filteredProjects.length === 0" class="rb-empty">
        <i class="el-icon-folder-opened rb-empty-icon"></i>
        <p class="rb-empty-text">暂无可管控的项目</p>
        <p class="rb-empty-hint">请回到子项目列表，勾选状态为 live 的项目并点击 "live管控" 添加</p>
      </div>

      <el-table
        v-else
        ref="projectTable"
        :data="filteredProjects"
        style="width: 100%"
        size="small"
        :row-class-name="tableRowClassName"
        :header-cell-style="{ background: '#fafbfc', color: '#606266', fontWeight: 600 }"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45" align="center"></el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row)" size="mini" effect="plain" class="rb-status-tag">
              <span class="rb-status-dot" :class="'rb-dot-' + getSortKey(scope.row)"></span>
              {{ getStatusLabel(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="项目名称" min-width="220" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="getStatusClass(scope.row)">{{ scope.row.pname }}</span>
          </template>
        </el-table-column>

        <el-table-column label="随机数目录" prop="remote_dirname" width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="rb-dirname">
              <i class="el-icon-folder"></i> {{ scope.row.remote_dirname || '-' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="进度" width="180" align="center">
          <template slot-scope="scope">
            <span class="rb-progress-text">{{ scope.row.remoteInfo.jindu || '0/0' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Links" width="150" align="center">
          <template slot-scope="scope">
            <div class="rb-cell-actions">
              <el-tooltip content="下载 links.xlsx" placement="top">
                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadLinks(scope.row)"></el-button>
              </el-tooltip>
              <el-upload
                class="rb-upload-cell"
                name="links"
                :action="upUrl"
                :headers="{ Authorization: token }"
                :data="{ pid: scope.row.id }"
                auto-upload
                :show-file-list="false"
                :before-upload="(file) => beforeExcelUpload(file, scope.row, 'links')"
                :on-success="(rs) => onUploadSuccess(rs, scope.row, 'links')"
                :on-error="(err) => onUploadError(err, scope.row, 'links')"
              >
                <el-tooltip content="上传 links.xlsx" placement="top">
                  <el-button type="text" size="mini" :icon="scope.row.uploadingLinks ? 'el-icon-loading' : 'el-icon-upload2'" :class="{ 'rb-uploading': scope.row.uploadingLinks }"></el-button>
                </el-tooltip>
              </el-upload>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Datamap" width="90" align="center">
          <template slot-scope="scope">
            <el-upload
              class="rb-upload-cell"
              name="datamap"
              :action="datamapUpUrl"
              :headers="{ Authorization: token }"
              :data="{ pid: scope.row.id }"
              auto-upload
              :show-file-list="false"
              :before-upload="(file) => beforeExcelUpload(file, scope.row, 'datamap')"
              :on-success="(rs) => onUploadSuccess(rs, scope.row, 'datamap')"
              :on-error="(err) => onUploadError(err, scope.row, 'datamap')"
            >
              <el-tooltip content="上传 datamap.xlsx" placement="top">
                <el-button type="text" size="mini" :icon="scope.row.uploadingDatamap ? 'el-icon-loading' : 'el-icon-upload2'" :class="{ 'rb-uploading': scope.row.uploadingDatamap }"></el-button>
              </el-tooltip>
            </el-upload>
          </template>
        </el-table-column>

        <el-table-column label="Logic" width="80" align="center">
          <template slot-scope="scope">
            <el-upload
              class="rb-upload-cell"
              name="logic"
              :action="logicUpUrl"
              :headers="{ Authorization: token }"
              :data="{ pid: scope.row.id }"
              auto-upload
              :show-file-list="false"
              :before-upload="(file) => beforeLogicUpload(file, scope.row, 'logic')"
              :on-success="(rs) => onUploadSuccess(rs, scope.row, 'logic')"
              :on-error="(err) => onUploadError(err, scope.row, 'logic')"
            >
              <el-tooltip content="上传 logic.xlsx（覆盖批量上传）" placement="top">
                <el-button type="text" size="mini" :icon="scope.row.uploadingLogic ? 'el-icon-loading' : 'el-icon-upload2'" :class="{ 'rb-uploading': scope.row.uploadingLogic }"></el-button>
              </el-tooltip>
            </el-upload>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="rb-row-actions">
              <el-tooltip content="运行" placement="top">
                <el-button type="primary" size="mini" icon="el-icon-video-play" :loading="scope.row.running" @click="runOne(scope.row)" circle></el-button>
              </el-tooltip>
              <el-tooltip content="close（结束报告）" placement="top">
                <el-button type="danger" size="mini" icon="el-icon-circle-close" :loading="scope.row.closing" @click="closeOne(scope.row)" plain circle></el-button>
              </el-tooltip>
              <el-tooltip content="刷新进度" placement="top">
                <el-button size="mini" icon="el-icon-refresh" @click="fetchRemoteState(scope.row)" circle></el-button>
              </el-tooltip>
              <el-tooltip content="从列表移除" placement="top">
                <el-button size="mini" icon="el-icon-delete" @click="removeProject(scope.row)" circle class="rb-btn-remove"></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="提示信息" min-width="160"  fixed="right">
          <template slot-scope="scope">
            <span v-if="scope.row.remoteInfo.cuowu" class="rb-err-text">
              <i class="el-icon-warning-outline"></i> {{ scope.row.remoteInfo.cuowu }}
            </span>
            <span v-else class="rb-no-err">—</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 单个项目 close 结束报告 -->
    <el-dialog
      :visible.sync="csDialog.show"
      title="项目结束报告"
      width="640px"
      top="8vh"
      :destroy-on-close="true"
    >
      <div class="rb-cs-title">
        <i class="el-icon-document"></i> {{ csDialog.pname }}
      </div>
      <table class="rb-cs-table">
        <tbody>
          <tr><th width="180">样本量</th><td>{{ csDialog.data.yangben }}</td></tr>
          <tr><th>中断量</th><td>{{ csDialog.data.zhongduan }}</td></tr>
          <tr><th>甄别量</th><td>{{ csDialog.data.zhenbie }}</td></tr>
          <tr><th>配额满量</th><td>{{ csDialog.data.peiem }}</td></tr>
          <tr><th>QC 量</th><td>{{ csDialog.data.qc }}</td></tr>
          <tr><th>平均完成时长</th><td>{{ csDialog.data.pingshichang }}</td></tr>
        </tbody>
      </table>
    </el-dialog>

    <!-- 批量 close 结果汇总 -->
    <el-dialog
      :visible.sync="batchCsDialog.show"
      title="批量 close 结果汇总"
      width="900px"
      top="6vh"
      :destroy-on-close="true"
    >
      <el-table :data="batchCsDialog.list" size="small" border>
        <el-table-column label="项目名称" prop="pname" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="样本量" prop="yangben" width="80" align="center"></el-table-column>
        <el-table-column label="中断量" prop="zhongduan" width="80" align="center"></el-table-column>
        <el-table-column label="甄别量" prop="zhenbie" width="80" align="center"></el-table-column>
        <el-table-column label="配额满量" prop="peiem" width="90" align="center"></el-table-column>
        <el-table-column label="QC量" prop="qc" width="80" align="center"></el-table-column>
        <el-table-column label="平均完成时长" prop="pingshichang" width="120" align="center"></el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ok" type="success" size="mini">成功</el-tag>
            <el-tooltip v-else placement="top" :content="scope.row.errMsg || '失败'">
              <el-tag type="danger" size="mini">失败</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "RemoteBatch",
  props: ["pid", "pname", "pcode"],
  data() {
    return {
      token: "Bearer " + localStorage.getItem("token"),
      projects: [],
      paoparam: {
        total: "",
        threads: "",
        delay: "0",
        step: "0",
      },
      batchRunning: false,
      batchClosing: false,
      batchLogicUploading: false,
      refreshing: false,
      loading: true,
      filterKey: "",
      selectedProjects: [],
      csDialog: {
        show: false,
        pname: "",
        data: { yangben: "", zhongduan: "", zhenbie: "", peiem: "", qc: "", pingshichang: "" },
      },
      batchCsDialog: {
        show: false,
        list: [],
      },
    };
  },
  computed: {
    upUrl() { return this.COMMON.httpUrl + "remoteSendLinks"; },
    datamapUpUrl() { return this.COMMON.httpUrl + "remoteSendDatamapUpload"; },
    logicUpUrl() { return this.COMMON.httpUrl + "remoteSendLogicUpload"; },
    batchLogicUpUrl() { return this.COMMON.httpUrl + "remoteBatchSendLogic"; },
    pidsJson() {
      return JSON.stringify(this.projects.map((p) => p.id));
    },
    sortedProjects() {
      return [...this.projects].sort((a, b) => {
        const order = { running: 0, completed: 1, not_running: 2 };
        return order[this.getSortKey(a)] - order[this.getSortKey(b)];
      });
    },
    filteredProjects() {
      if (!this.filterKey) return this.sortedProjects;
      return this.sortedProjects.filter((p) => this.getSortKey(p) === this.filterKey);
    },
    statCounts() {
      const counts = { running: 0, completed: 0, not_running: 0 };
      this.projects.forEach((p) => { counts[this.getSortKey(p)]++; });
      return counts;
    },
  },
  created() {
    this.loadProjects();
  },
  methods: {
    loadProjects() {
      this.loading = true;
      // 读取暂存的待添加项目
      var pendingJson = sessionStorage.getItem('remoteBatchPending');
      var pending = [];
      if (pendingJson) {
        try { pending = JSON.parse(pendingJson); } catch (e) { pending = []; }
        sessionStorage.removeItem('remoteBatchPending');
      }
      var api = this.COMMON.httpUrl + "remoteGetBatchProjects";
      this.axios.post(api, { pid: this.pid }).then((response) => {
        var rs = response.data;
        var existing = (rs.code === 0 && rs.data) ? rs.data : [];
        // 合并暂存项目（去重）
        if (pending.length > 0) {
          var existingIds = new Set(existing.map(p => p.id));
          pending.forEach(p => {
            if (!existingIds.has(p.id)) {
              existing.push(p);
            }
          });
        }
        if (existing.length > 0) {
          this.projects = existing.map((p) => ({
            ...p,
            remoteInfo: {
              state: "",
              dirname: p.remote_dirname || "",
              jindu: "0/0",
              cuowu: "",
            },
            running: false,
            closing: false,
            isAnimating: false,
            uploadingLinks: false,
            uploadingDatamap: false,
            uploadingLogic: false,
          }));
          // 有新增项目时保存回Redis
          if (pending.length > 0) {
            this.saveProjects();
          }
          this.refreshAll();
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$message.error("加载项目数据失败");
      });
    },
    saveProjects() {
      var api = this.COMMON.httpUrl + "remoteSaveBatchProjects";
      var list = this.projects.map((p) => ({
        id: p.id,
        pname: p.pname,
        pcode: p.pcode,
        remote_dirname: p.remote_dirname,
        remote_state: p.remote_state,
      }));
      this.axios.post(api, { pid: this.pid, projects: JSON.stringify(list) });
    },

    // ===== 状态相关 =====
    getSortKey(row) {
      const jindu = row.remoteInfo.jindu || "0/0";
      if (!jindu || jindu === "0/0") return "not_running";
      const parts = jindu.split("/");
      if (parts.length === 2) {
        const current = parseInt(parts[0]) || 0;
        const total = parseInt(parts[1]) || 0;
        if (current > 0 && current < total) return "running";
        if (current > 0 && current >= total) return "completed";
      }
      return "not_running";
    },
    getStatusLabel(row) {
      const key = this.getSortKey(row);
      const labels = { running: "进行中", completed: "已完成", not_running: "未运行" };
      return labels[key];
    },
    getStatusTagType(row) {
      const key = this.getSortKey(row);
      const types = { running: "success", completed: "info", not_running: "warning" };
      return types[key];
    },
    getStatusClass(row) {
      const key = this.getSortKey(row);
      return { "rb-name-running": key === "running", "rb-name-completed": key === "completed" };
    },
    tableRowClassName({ row }) {
      return "rb-row rb-row-" + this.getSortKey(row);
    },
    getPercent(row) {
      const jindu = row.remoteInfo.jindu || "0/0";
      const parts = jindu.split("/");
      if (parts.length === 2) {
        const c = parseInt(parts[0]) || 0;
        const t = parseInt(parts[1]) || 0;
        if (t > 0) return Math.min(100, Math.round((c / t) * 100));
      }
      return 0;
    },
    getProgressStatus(row) {
      const key = this.getSortKey(row);
      if (key === "completed") return "success";
      if (key === "running") return null;
      return "exception";
    },

    // ===== 刷新 =====
    refreshAll() {
      this.refreshing = true;
      let completed = 0;
      const total = this.projects.length;
      if (total === 0) {
        this.refreshing = false;
        return;
      }
      this.projects.forEach((proj) => {
        this.fetchRemoteState(proj, () => {
          completed++;
          if (completed === total) {
            this.refreshing = false;
          }
        });
      });
    },
    fetchRemoteState(proj, callback) {
      var api = this.COMMON.httpUrl + "remoteState";
      var data = { pid: proj.id };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          proj.remoteInfo = { state: "", dirname: proj.remote_dirname, jindu: "0/0", cuowu: rs.message };
        } else {
          proj.remoteInfo = rs.data;
        }
        proj.isAnimating = true;
        setTimeout(() => { proj.isAnimating = false; }, 1000);
        if (callback) callback();
      }).catch(() => {
        if (callback) callback();
      });
    },

    // ===== 单个运行（直调 remoteRun，跳过 fsreport 对话框）=====
    runOne(proj) {
      if (!this.validateRunParams()) return;
      this.$confirm(`确认运行 "${proj.pname}"？总数：${this.paoparam.total}，并发：${this.paoparam.threads}`, "运行确认", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        this.doRun(proj);
      }).catch(() => {});
    },
    doRun(proj) {
      proj.running = true;
      var api = this.COMMON.httpUrl + "remoteRun";
      var data = {
        pid: proj.id,
        total: this.paoparam.total,
        threads: this.paoparam.threads,
        delay: this.paoparam.delay,
        step: this.paoparam.step,
      };
      return this.axios.post(api, data).then((response) => {
        var rs = response.data;
        proj.running = false;
        if (rs.code) {
          this.$message.error(`${proj.pname}：${rs.message}`);
          return false;
        }
        this.$message.success(`${proj.pname}：运行成功`);
        if (rs.data) {
          proj.remoteInfo.jindu = rs.data.jindu || proj.remoteInfo.jindu;
          proj.remoteInfo.cuowu = rs.data.cuowu || "";
        }
        return true;
      }).catch(() => {
        proj.running = false;
        return false;
      });
    },
    validateRunParams() {
      if (this.paoparam.total.trim().length === 0 || this.paoparam.threads.trim().length === 0) {
        this.$message.warning('启动参数中"总数"和"并发数"不能为空！');
        return false;
      }
      return true;
    },

    // ===== 批量运行 =====
    batchRun() {
      if (!this.validateRunParams()) return;
      if (this.projects.length === 0) {
        this.$message.warning("没有可运行的项目");
        return;
      }
      this.$confirm(
        `确认对 ${this.projects.length} 个项目批量运行？总数：${this.paoparam.total}，并发数：${this.paoparam.threads}`,
        "批量运行确认",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      ).then(() => {
        this.batchRunning = true;
        this.runProjectsSequentially(0);
      }).catch(() => {});
    },
    runProjectsSequentially(index) {
      if (index >= this.projects.length) {
        this.batchRunning = false;
        this.$message.success("批量运行全部完成");
        this.refreshAll();
        return;
      }
      const proj = this.projects[index];
      this.doRun(proj).finally(() => {
        this.runProjectsSequentially(index + 1);
      });
    },

    // ===== 单个 close =====
    closeOne(proj) {
      this.$confirm(`确认对 "${proj.pname}" 执行 close？`, "Close 确认", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        proj.closing = true;
        var api = this.COMMON.httpUrl + "remoteCsReport";
        this.axios.post(api, { pid: proj.id }).then((response) => {
          proj.closing = false;
          var rs = response.data;
          if (rs.code) {
            this.$message.error(`${proj.pname}：${rs.message}`);
            return;
          }
          this.csDialog.pname = proj.pname;
          this.csDialog.data = {
            yangben: rs.data.yangben,
            zhongduan: rs.data.zhongduan,
            zhenbie: rs.data.zhenbie,
            peiem: rs.data.peiem,
            qc: rs.data.qc,
            pingshichang: rs.data.shichang,
          };
          this.csDialog.show = true;
        }).catch(() => {
          proj.closing = false;
          this.$message.error(`${proj.pname}：请求异常`);
        });
      }).catch(() => {});
    },

    // ===== 批量 close（依次请求并汇总展示）=====
    batchClose() {
      if (this.projects.length === 0) {
        this.$message.warning("没有可 close 的项目");
        return;
      }
      this.$confirm(`确认对 ${this.projects.length} 个项目批量 close？`, "批量 close 确认", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        this.batchClosing = true;
        this.batchCsDialog.list = [];
        this.closeProjectsSequentially(0);
      }).catch(() => {});
    },
    closeProjectsSequentially(index) {
      if (index >= this.projects.length) {
        this.batchClosing = false;
        this.batchCsDialog.show = true;
        this.$message.success("批量 close 完成");
        return;
      }
      const proj = this.projects[index];
      proj.closing = true;
      var api = this.COMMON.httpUrl + "remoteCsReport";
      this.axios.post(api, { pid: proj.id }).then((response) => {
        proj.closing = false;
        var rs = response.data;
        if (rs.code) {
          this.batchCsDialog.list.push({
            pname: proj.pname, ok: false, errMsg: rs.message,
            yangben: "-", zhongduan: "-", zhenbie: "-", peiem: "-", qc: "-", pingshichang: "-",
          });
        } else {
          this.batchCsDialog.list.push({
            pname: proj.pname, ok: true,
            yangben: rs.data.yangben,
            zhongduan: rs.data.zhongduan,
            zhenbie: rs.data.zhenbie,
            peiem: rs.data.peiem,
            qc: rs.data.qc,
            pingshichang: rs.data.shichang,
          });
        }
        this.closeProjectsSequentially(index + 1);
      }).catch((e) => {
        proj.closing = false;
        this.batchCsDialog.list.push({
          pname: proj.pname, ok: false, errMsg: (e && e.message) || "请求异常",
          yangben: "-", zhongduan: "-", zhenbie: "-", peiem: "-", qc: "-", pingshichang: "-",
        });
        this.closeProjectsSequentially(index + 1);
      });
    },

    // ===== 移除 =====
    removeProject(proj) {
      this.$confirm(`确认从列表移除 "${proj.pname}"？`, "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
      }).then(() => {
        this.projects = this.projects.filter((p) => p.id !== proj.id);
        this.saveProjects();
        this.$message.info(`已移除项目：${proj.pname}`);
      }).catch(() => {});
    },
    handleSelectionChange(val) {
      this.selectedProjects = val;
    },
    batchRemove() {
      if (this.selectedProjects.length === 0) return;
      var names = this.selectedProjects.map((p) => p.pname).join('、');
      this.$confirm(`确定要移除以下 ${this.selectedProjects.length} 个项目吗？\n${names}`, '批量移除确认', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',
      }).then(() => {
        var removeIds = new Set(this.selectedProjects.map((p) => p.id));
        this.projects = this.projects.filter((p) => !removeIds.has(p.id));
        this.saveProjects();
        this.$message.info(`已移除 ${this.selectedProjects.length} 个项目`);
      }).catch(() => {});
    },

    // ===== 文件上传 =====
    beforeExcelUpload(file, row, type) {
      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (fileName !== "xls" && fileName !== "xlsx") {
        this.$message.warning("上传文件只能是 xls、xlsx 格式!");
        return false;
      }
      if (row && type) row['uploading' + type.charAt(0).toUpperCase() + type.slice(1)] = true;
    },
    beforeLogicUpload(file, row, type) {
      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (fileName !== "xls" && fileName !== "xlsx") {
        this.$message.warning("上传文件只能是 xls、xlsx 格式!");
        return false;
      }
      if (row && type) row['uploading' + type.charAt(0).toUpperCase() + type.slice(1)] = true;
    },
    onUploadSuccess(rs, row, type) {
      if (row && type) row['uploading' + type.charAt(0).toUpperCase() + type.slice(1)] = false;
      if (rs.code) {
        this.$message.error(rs.message);
      } else {
        this.$message.success(rs.message || "上传成功");
        if (row) this.fetchRemoteState(row);
      }
    },
    beforeBatchLogicUpload(file) {
      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (fileName !== "xls" && fileName !== "xlsx") {
        this.$message.warning("上传文件只能是 xls、xlsx 格式!");
        return false;
      }
      this.batchLogicUploading = true;
    },
    onBatchLogicSuccess(rs) {
      this.batchLogicUploading = false;
      if (rs.code) {
        this.$message.error(rs.message);
      } else {
        this.$message.success(rs.message || "批量上传 logic 完成");
      }
    },
    onBatchLogicError(err) {
      this.batchLogicUploading = false;
      this.$message.error("批量上传失败：" + (err.message || "网络异常"));
    },
    onUploadError(err, row, type) {
      if (row && type) row['uploading' + type.charAt(0).toUpperCase() + type.slice(1)] = false;
      this.$message.error("上传失败：" + (err.message || "网络异常"));
    },

    // ===== 文件下载 =====
    downloadLinks(proj) {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        body: JSON.stringify({ pid: proj.id, fname: "links.xlsx" }),
      };
      let src = this.COMMON.httpUrl + "remoteLogDown";
      fetch(src, requestOptions)
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw new Error(errorData.message || "下载异常");
            });
          }
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.download = `${proj.pcode || 'links'}-links.xlsx`;
          a.href = url;
          a.click();
        })
        .catch((error) => {
          this.$message.error(error.message || "下载失败");
        });
    },
  },
};
</script>

<style scoped>
.rb-page {
  padding: 4px;
}

/* ===== Header ===== */
.rb-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: linear-gradient(135deg, #ffffff 0%, #f7fafe 100%);
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid #ebeef5;
}
.rb-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}
.rb-back {
  cursor: pointer;
  color: #606266;
  font-style: normal;
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all .2s;
}
.rb-back:hover {
  background: #ecf5ff;
  color: #409EFF;
}
.rb-divider-v {
  width: 1px;
  height: 14px;
  background: #dcdfe6;
}
.rb-label {
  font-size: 12px;
  color: #909399;
}
.rb-value {
  font-size: 13px;
  color: #303133;
  font-weight: 500;
  margin-right: 4px;
}
.rb-tag-live {
  background: linear-gradient(135deg, #409EFF, #67c1ff) !important;
  border-color: transparent !important;
}
.rb-tag-live i { margin-right: 4px; }
.rb-count-total {
  font-size: 13px;
  color: #606266;
}
.rb-count-total b {
  color: #409EFF;
  font-size: 15px;
  font-weight: 700;
  margin: 0 2px;
}

/* ===== 统计胶囊 ===== */
.rb-stats {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: center;
}
.rb-stat-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #ebeef5;
  transition: all .25s;
  position: relative;
  overflow: hidden;
}
.rb-stat-item::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 3px;
  background: currentColor;
  opacity: .6;
}
.rb-stat-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}
.rb-stat-item.active {
  box-shadow: 0 0 0 2px currentColor inset;
}
.rb-stat-running { color: #67C23A; }
.rb-stat-completed { color: #909399; }
.rb-stat-not_running { color: #E6A23C; }
.rb-stat-dot {
  width: 10px; height: 10px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 0 4px rgba(103, 194, 58, 0.15);
}
.rb-stat-completed .rb-stat-dot { box-shadow: 0 0 0 4px rgba(144, 147, 153, 0.15); }
.rb-stat-not_running .rb-stat-dot { box-shadow: 0 0 0 4px rgba(230, 162, 60, 0.15); }
.rb-stat-num {
  font-size: 22px;
  font-weight: 700;
  color: currentColor;
  line-height: 1;
}
.rb-stat-label {
  font-size: 13px;
  color: #606266;
}
.rb-stat-clear {
  font-size: 12px;
  color: #909399;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  transition: all .2s;
}
.rb-stat-clear:hover { background: #f4f4f5; color: #606266; }

/* ===== 卡片 ===== */
.rb-card {
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.rb-card :deep(.el-card__header) {
  padding: 12px 18px;
  background: #fafbfc;
  border-bottom: 1px solid #ebeef5;
}
.rb-card :deep(.el-card__body) {
  padding: 16px 18px;
}
.rb-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.rb-card-header i { color: #409EFF; font-size: 16px; }
.rb-card-hint {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
  margin-left: 4px;
}

/* ===== 批量操作区 ===== */
.rb-control-grid {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.rb-control-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}
.rb-control-row-btns {
  padding-top: 10px;
  border-top: 1px dashed #ebeef5;
}
.rb-control-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rb-form-label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
  min-width: 60px;
  text-align: right;
}
.rb-control-cell :deep(.el-input) {
  width: 160px;
}
.rb-upload-inline { display: inline-block; }
.rb-btn-light {
  color: #909399;
  border-color: #dcdfe6;
}
.rb-btn-light:hover {
  color: #F56C6C;
  border-color: #F56C6C;
  background: #fef0f0;
}

/* ===== 列表区 ===== */
.rb-card-list :deep(.el-card__body) {
  padding: 0;
}
.rb-card-list :deep(.el-card__header) {
  border-bottom: 1px solid #ebeef5;
}
.rb-card-list :deep(.el-table) {
  border-radius: 0 0 8px 8px;
}
.rb-card-list :deep(.el-table::before) {
  display: none;
}
.rb-empty {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}
.rb-empty-icon { font-size: 56px; color: #c0c4cc; }
.rb-empty-text { font-size: 15px; margin: 12px 0 4px; color: #606266; }
.rb-empty-hint { font-size: 12px; color: #c0c4cc; }

.rb-loading {
  text-align: center;
  padding: 80px 20px;
  color: #909399;
}
.rb-loading-icon { font-size: 36px; color: #409EFF; }
.rb-loading-text { font-size: 14px; margin-top: 16px; color: #606266; }

/* ===== 行 / 状态 ===== */
:deep(.rb-row td) {
  position: relative;
  padding: 8px 0;
}
:deep(.rb-row-running td:first-child::before) {
  content: '';
  position: absolute;
  left: 0; top: 4px; bottom: 4px;
  width: 3px;
  background: #67C23A;
  border-radius: 0 2px 2px 0;
}
:deep(.rb-row-completed td:first-child::before) {
  content: '';
  position: absolute;
  left: 0; top: 4px; bottom: 4px;
  width: 3px;
  background: #c0c4cc;
  border-radius: 0 2px 2px 0;
}
:deep(.rb-row-not_running td:first-child::before) {
  content: '';
  position: absolute;
  left: 0; top: 4px; bottom: 4px;
  width: 3px;
  background: #E6A23C;
  border-radius: 0 2px 2px 0;
}
.rb-status-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  border-radius: 10px;
  padding: 0 8px;
}
.rb-status-dot {
  display: inline-block;
  width: 6px; height: 6px;
  border-radius: 50%;
}
.rb-dot-running { background: #67C23A; box-shadow: 0 0 0 3px rgba(103,194,58,.15); animation: pulse 1.6s infinite; }
.rb-dot-completed { background: #909399; }
.rb-dot-not_running { background: #E6A23C; }
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(103,194,58,.4); }
  70% { box-shadow: 0 0 0 6px rgba(103,194,58,0); }
  100% { box-shadow: 0 0 0 0 rgba(103,194,58,0); }
}

.rb-proj-name {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.4;
}
.rb-name-running { color: #303133; font-weight: 600; }
.rb-name-completed { color: #909399; }
.rb-proj-code { font-size: 11px; color: #c0c4cc; }
.rb-dirname {
  font-size: 12px;
  color: #606266;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.rb-dirname i { color: #c0c4cc; }

/* ===== 进度 ===== */
.rb-progress-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 6px;
}
.rb-progress-wrap :deep(.el-progress-bar__outer) {
  background-color: #f0f2f5;
}
.rb-progress-text {
  font-size: 12px;
  color: #606266;
  font-weight: 600;
  text-align: center;
  letter-spacing: .3px;
}
.rb-progress-wrap.animate .rb-progress-text {
  animation: dropIn .6s ease;
}
@keyframes dropIn {
  0% { opacity: 0; transform: translateY(-4px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* ===== 单元格按钮 ===== */
.rb-cell-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.rb-cell-actions :deep(.el-button) {
  padding: 4px 6px;
  font-size: 15px;
}
.rb-upload-cell { display: inline-block; }
.rb-upload-cell :deep(.el-button) {
  padding: 4px 6px;
  font-size: 15px;
}
.rb-uploading :deep(.el-icon-loading) {
  animation: rb-spin 1s linear infinite;
  color: #409EFF;
}
@keyframes rb-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.rb-row-actions {
  display: inline-flex;
  gap: 4px;
}
.rb-row-actions :deep(.el-button) {
  padding: 5px;
}
.rb-btn-remove {
  color: #909399;
  border-color: #dcdfe6;
}
.rb-btn-remove:hover {
  color: #F56C6C !important;
  border-color: #F56C6C !important;
  background: #fef0f0 !important;
}
.rb-err-text {
  color: #F56C6C;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.rb-no-err {
  color: #c0c4cc;
  font-size: 12px;
}

/* ===== close 报告对话框 ===== */
.rb-cs-title {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #ecf5ff;
  border-left: 3px solid #409EFF;
  border-radius: 0 4px 4px 0;
}
.rb-cs-title i { margin-right: 6px; color: #409EFF; }
.rb-cs-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}
.rb-cs-table th, .rb-cs-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #ebeef5;
}
.rb-cs-table tr:last-child th, .rb-cs-table tr:last-child td {
  border-bottom: none;
}
.rb-cs-table th {
  background: #fafbfc;
  color: #606266;
  font-weight: 500;
  width: 140px;
}
.rb-cs-table td {
  color: #303133;
  font-weight: 600;
}
</style>
